const request = {}

request.createRequest = function (params) {
  return {
    supplierId: params.supplierId,
    isHideUnusedProduct: params.isHideUnusedProduct
  }
}
export default { request }
